import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { Button, Card, DataTable, TextInput, tokens } from '../UI';

const columns = [
  {
    name: 'When',
    selector: 'created_at',
    sortable: true,
    cell: (row) => new Date(row.created_at).toLocaleString(),
  },
  { name: 'Actor', selector: 'actor_id', cell: (row) => `${row.actor_id} (${row.actor_role})` },
  { name: 'Action', selector: 'action' },
  { name: 'Resource', cell: (row) => `${row.resource_type} ${row.resource_id}` },
  { name: 'Reason', selector: 'reason' },
  {
    name: '',
    right: true,
    cell: (row) => (
      <Link to={`/audit/${row.id}`}>
        <Button size="sm" variant="outline">Details</Button>
      </Link>
    ),
  },
];

export default function AuditLogList() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({ actor_id: '', resource_type: '', action: '' });
  const [page, setPage] = useState(0);
  const limit = 25;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams({
      ...filter,
      limit: String(limit),
      offset: String(page * limit),
    }).toString();
    fetchData(`${Endpoints.LIST_AUDIT}?${qs}`)
      .then((res) => res.json())
      .then((res) => {
        setLogs(res.logs || []);
        setTotal(res.total || 0);
        setLoading(false);
      });
  }, [filter, page]);

  return (
    <PageLayout title="Audit log">
      <Card style={{ marginBottom: tokens.spacing[4] }}>
        <div style={{ display: 'flex', gap: tokens.spacing[3], flexWrap: 'wrap' }}>
          <TextInput
            style={{ flex: '1 1 180px' }}
            placeholder="Actor ID"
            value={filter.actor_id}
            onChange={(e) => setFilter({ ...filter, actor_id: e.target.value })}
          />
          <TextInput
            style={{ flex: '1 1 180px' }}
            placeholder="Resource type"
            value={filter.resource_type}
            onChange={(e) => setFilter({ ...filter, resource_type: e.target.value })}
          />
          <TextInput
            style={{ flex: '1 1 180px' }}
            placeholder="Action"
            value={filter.action}
            onChange={(e) => setFilter({ ...filter, action: e.target.value })}
          />
        </div>
      </Card>
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={logs}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={total}
          paginationPerPage={limit}
          onChangePage={(p) => setPage(p - 1)}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
